export const COUNTRIES = {
  CO: {
    LABEL: "CO",
  },
  MX: {
    LABEL: "MX",
  },
};
